<template>
  <section class="header-container" v-if="!fileStoreStore.isMobile">
    <nav>
      <button class="back-button" @click="goBack">
        <img src="../../../images/icons/chevron-left-solid.svg" />
      </button>
      <span>
        <span
          >{{ searchResultCount }}
          {{ searchResultCount === 1 ? 'zoekresultaat' : 'zoekresultaten' }}
          voor
        </span>
        <span class="sub-color">{{ searchOptions.searchString }}</span>
        <span v-if="searchOptions.folderId">
          in <span class="sub-color">{{ getFolderName() }}</span></span
        >
        <span v-else-if="searchOptions.archiveId">
          in <span class="sub-color">{{ getArchiveName() }}</span></span
        >
        <span v-else> in alle archieven</span>
      </span>
    </nav>

    <nav class="top-menu">
      <template v-if="fileStoreStore.hasSelectedFiles">
        <button class="main-button" @click="trashSelectedFiles()">
          naar prullenmand
        </button>
      </template>
    </nav>
    <search-menu :prevent-selection="true"></search-menu>
  </section>

  <section class="header-mobile" v-else>
    <section class="header-top">
      <nav class="top-menu">
        <template v-if="fileStoreStore.hasSelectedFiles">
          <button class="main-button" @click="trashSelectedFiles()">
            naar prullenmand
          </button>
        </template>
      </nav>
      <search-menu :prevent-selection="true"></search-menu>
    </section>
    <nav class="header-bottom">
      <button class="back-button" @click="goBack">
        <img src="../../../images/icons/chevron-left-solid.svg" />
      </button>
      <span>
        <span
          >{{ searchResultCount }}
          {{ searchResultCount === 1 ? 'zoekresultaat' : 'zoekresultaten' }}
          voor
        </span>
        <span class="sub-color">{{ searchOptions.searchString }}</span>
        <span v-if="searchOptions.folderId">
          in <span class="sub-color">{{ getFolderName() }}</span></span
        >
        <span v-else-if="searchOptions.archiveId">
          in <span class="sub-color">{{ getArchiveName() }}</span></span
        >
        <span v-else> in alle archieven</span>
      </span>
    </nav>
  </section>
</template>

<script>
import SearchMenu from '@/features/filestore/children/SearchMenu.vue'
import FileNavigationMixin from '@/features/filestore/FileNavigationMixin.js'
import { mapStores } from 'pinia'
import { useFileStoreStore } from '@/features/filestore/FileStore.store'

export default {
  components: { SearchMenu },
  mixins: [FileNavigationMixin],
  computed: {
    ...mapStores(useFileStoreStore),
    searchResultCount() {
      return this.fileStoreStore.searchResultCount
    },
    searchOptions() {
      return this.fileStoreStore.searchOptions
    }
  },
  methods: {
    getFolderName() {
      return this.fileStoreStore.getFolder(this.searchOptions.folderId).name
    },
    getArchiveName() {
      return this.fileStoreStore.getArchive(this.searchOptions.archiveId).name
    },
    goBack() {
      this.$router.push({ name: 'fileStoreDashboard' })
    }
  }
}
</script>

<style scoped lang="scss">
.back-button {
  //min-width: 20px;
  margin-right: 4px;

  svg {
    width: 20px;
    height: 20px;

    path,
    rect {
      fill: var(--sub-color);
    }
  }
}

.header-container {
  display: grid;
  grid-template-columns: auto 10px 40px;
  width: 100%;
  height: 100%;
  align-items: center;
  font-weight: 500;
  font-size: 13px;

  nav {
    display: flex;
    overflow: hidden;
    align-items: center;

    > span {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 20px;
    }
  }

  .top-menu {
    display: flex;
    justify-content: flex-end;
    margin-right: 10px;
  }
}

.header-mobile {
  width: 100%;
  .header-top {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 24px;
    padding-right: 8px;
  }
  .header-bottom {
    margin-left: -8px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 24px;
    .back-button {
      margin-right: 8px;
    }
  }
}
</style>
